<script>
  import ListFile from "@components/List/FileTable";

  export default {
    components: {
      ListFile
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
  }
</script>
<template>
  <section id="file" class="section bg-gray-2">
    <div class="container">
      <BaseSectionTitle
        title="檔案下載"
        class="text-center"
      />
      <ListFile
        :list="list"
        type="download"
      />
      <div class="text-center">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'brand-file' }"
        >
          查看所有下載
        </BaseButton>
      </div>
    </div>
  </section>
</template>
